import { makeStyles } from '@material-ui/core/styles';

export const useStyles = makeStyles({
  image: {
    width: '100%',
    boxShadow: '2px 2px 5px gray'
  },
  imageGrid: {
    width: '80vw',
    margin: '0 auto'
  },
  button: {
    margin: '20px auto 0 auto'
  }
});
